// import { useState } from 'react';
// import { makeStyles } from '@mui/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import Paper from '@mui/material/Paper';
// import Container from '@mui/material/Container';
// import {
//     Player,
//     ControlBar,
//     PlaybackRateMenuButton,
//     VolumeMenuButton,
//     BigPlayButton,
//     CurrentTimeDisplay,
//     TimeDivider
// } from 'video-react';

// const useStyles = makeStyles({
//     paper: {
//         padding: '20px',
//         backgroundColor: '#f5f5f5',
//     },
// });

const Video = (props) => {
    // const classes = useStyles();
    // const [conteudo] = useState({
    //     ...props.conteudo
    // });

    return (
        <>
            {/* <CssBaseline />
            <Container className={classes.paper} component={Paper}>
                <Player
                    playsInline
                    poster={conteudo.video.posterUrl}
                >
                    <BigPlayButton position="center" />
                    <source
                        src={conteudo.video.videoUrl}
                        type="video/mp4"
                    />
                    <ControlBar>
                        <VolumeMenuButton order={1.1} vertical />
                        <CurrentTimeDisplay order={4.1} />
                        <TimeDivider order={4.2} />
                        <PlaybackRateMenuButton rates={[0.25, 0.5, 0.75, 1, 1.25, 1.75, 2]} order={7.1} />
                    </ControlBar>
                </Player>
            </Container> */}

        </>
    );
}

export default Video;